import { z } from 'zod';
import { usePage } from '@tap/tap-ui';
import { DocumentCode } from '@tap/data-providers';


export type EntityId = number;
export type DocumentKey = `${DocumentCode}-${EntityId}`;

export type DocumentKeyParts = {
    documentKey: DocumentKey,
    documentCode: DocumentCode,
    entityId: number,
}

const validateDocumentKey = (value: string, ctx: z.RefinementCtx) => {
    if (!value) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `DocumentKey can't be empty`,
        });

        return z.NEVER;
    }
    const parts = value.split('-');

    if (parts.length !== 2) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `DocumentKey format should be ABC-12345`,
        });

        return z.NEVER;
    }
}

const parseDocumentKey = (value: string) => {
    const documentKey = value.toUpperCase() as DocumentKey;
    const [documentCode, entityId] = documentKey.split('-');

    return {
        documentKey,
        documentCode,
        entityId: parseInt(entityId, 10),
    } as DocumentKeyParts;
}

export const documentPageRouteParams = z.object({
    documentKey: z.coerce.string()
        .superRefine(validateDocumentKey)
        .transform(parseDocumentKey),

})

export type DocumentPageRouteParams = z.infer<typeof documentPageRouteParams>;

export type DocumentDetailsTargetPage = React.FC<DocumentKeyParts>;


export type ChooseDocumentDetailsPageParams = {
    pages: { [key in DocumentCode]?: DocumentDetailsTargetPage },
}

export const ChooseDocumentDetailsPage = ({ pages }: ChooseDocumentDetailsPageParams) => {

    const { pageRouteParams } = usePage<DocumentPageRouteParams>();

    const { documentKey, documentCode } = pageRouteParams.documentKey;

    if (Object.prototype.hasOwnProperty.call(pages, documentCode)) {
        const TargetPage = pages[documentCode]!;
        return <TargetPage key={documentKey} {...pageRouteParams.documentKey} />;
    }
    else if (Object.values(DocumentCode).includes(documentCode)) {
        // Перегружаем страницу, т.к. этот роут обрабатывается другим приложением
        window.location.reload();

    }

    return <></>;
}

